
<section class="container my-4">
  <div class="alert alert-success" role="alert">
    El valor a pagar es de 5.00 $
  </div>
  <button type="button" class="btn btn-primary" (click)="payment()">Pagar</button>

  <form [action]="url" class="paymentWidgets" data-brands="VISA MASTER"></form>
</section>
